import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructionFinalPage',
  setup(__props, { expose }) {
  expose();

const messages = {
  no: {
    title: 'Da starter spillet',
  },
  en: {
    title: 'Lets start the game now!',
  },
}
const { t } = useI18n({ messages })

const __returned__ = { messages, t }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})